import React, { useState } from 'react' //for using react function based components u can use (rfc)<- most important
function TextForm(props) {
    const HandleUpclick = () => {
        const newtext = Text.toUpperCase();
        SetText(newtext);
        props.showAlert("Converted to UpperCase","success");
    }
    const HandleOnchange = (event) => {
        SetText(event.target.value);
    }
    const HandleLoclick = () => {
        const newmem = Text.toLowerCase();
        SetText(newmem);
        props.showAlert("Converted to LowerCase","success");
    }
    const Handledelete = () => {
        SetText("");
        props.showAlert("Content Deleted","danger");
    }
    const HandleEmail = () => {
        const random = Math.floor(Math.random() * 10000 + 1000);
        SetText(Text + random + "@gmail.com");
        props.showAlert("Created an Email Id","success");
    }
    const Handlecopy = () => {
        const text = document.getElementById("exampleFormControlTextarea1");
        text.select();
        navigator.clipboard.writeText(text.value);
        props.showAlert("Succesfully added to Clipboard","success");
    }
    const [Text, SetText] = useState("");
    //Text = "new text"; wrong way to set text
    // SetText("new Text")//correct way to set the text
    return (
        <>
            <div className="container">
                <div className="mb-3">
                    <h1 style={{ color: props.mode === 'light' ? 'black' : 'white' }}>{props.heading}</h1>
                    <textarea className="form-control" id="exampleFormControlTextarea1" onChange={HandleOnchange} value={Text} rows="8" style={{ backgroundColor: props.mode === 'light' ? 'white' : 'black', color: props.mode === 'light' ? 'black' : 'white',border:props.mode ==='light'?'2px solid black':'2px solid white',borderRadius:'15px'}}></textarea>
                </div>
                <div className="button btn btn-success mx-3 mb-3" onClick={HandleUpclick}>Convert to Uppercase</div>
                <div className="button btn btn-warning mx-3 mb-3" onClick={HandleLoclick}>Convert to LowerCase</div>
                <div className="button btn btn-danger mx-3 mb-3" onClick={Handledelete}>Clear Content</div>
                <div className="button btn btn-primary mx-3 mb-3" onClick={HandleEmail}>Convert To Mail</div>
                <div className="button btn btn-info mx-3 mb-3" onClick={Handlecopy}>Copy Content</div>
            </div>
            <div className="container my-3 mx-3" style={{ color: props.mode === 'light' ? 'black' : 'white' }}>
                <h1>Yours Text Summary</h1>
                <p>{Text.split(" ").length - 1} words and {Text.length} Characters</p>
                <p>The text will take {(0.008) * (Text.split(" ").length - 1)} minutes to Read</p>
                <h1>Preview</h1>
                <p>{Text.length===0?'Enter text in the TextArea':Text}</p>
            </div>
        </>
    );

}
export default TextForm;